import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { StateService } from '../utils/store/state.service';
import { inject } from '@angular/core';
import { ICurrencyType, IOfficeSelect } from '../interfaces/domain/office.interface';

@Injectable({
  providedIn: 'root',
})
export class CoreService {
  private stateService: StateService = inject(StateService);    
  private officeSelectedState: Subject<string> = new Subject<string>();
  private readonly menu_show = new Subject<string>();
  private officeSelectedStateName: string = 'officeSelected';
  private currencyTypeStateName: string = 'currencyType';
  private officeName: string = '';
  private currencyType: ICurrencyType = this.stateService.get(this.currencyTypeStateName) ?? { code: 'EUR', symbol: '€' };

  setMenuShow(value: string) {
    this.menu_show.next(value);
  }

  get onMenuShow() {
    return this.menu_show.asObservable();
  }

  setOfficeSelected(office: IOfficeSelect) {
    this.stateService.save({name: this.officeSelectedStateName, value: office.id});
    this.stateService.save({name: this.currencyTypeStateName, value: office.currencyType});
    this.officeSelectedState.next(office.id);
    this.currencyType = office.currencyType;
    this.officeName = office.name;
  }

  get getOfficeSelected(): string | null {
    return this.stateService.get(this.officeSelectedStateName) ?? null;
  }

  onOfficeSelectedChange() {
    return this.officeSelectedState.asObservable();
  }

  get getCurrencyType(): ICurrencyType {
    return this.currencyType;
  }

  get getOfficeName(): string {
    return this.officeName;
  }
}
